import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

import {MediaService} from '../../media/media.service';
import {FormControl} from '@angular/forms';
import {Media} from '../../media/media.model';
import {GlobalVariable} from '../../../global';
import {ConfigLoaderService} from '../../../app-loader/config-loader.service';
import {PlatformConfig} from '../../../app-loader/platform-config';

@Component({
  selector: 'app-photo-block',
  templateUrl: './photo-block.component.html',
  styleUrls: ['./photo-block.component.scss']
})
export class PhotoBlockComponent implements OnInit {

  @Input('photoFormControl') photoFormControl: FormControl;
  @Input() placeholder: string;
  @Output() onMediaSelected: EventEmitter<Media> = new EventEmitter<Media>();

  mediaUrl: any = null;
  mediaLoading: boolean = false;
  mediaBaseUrl = GlobalVariable.BASE_MEDIA_URL;
  hasPostMediaPermission = false;
  permissions = [] ;
  platformConfig: PlatformConfig;

  constructor(private mediaService: MediaService, public configLoaderService: ConfigLoaderService) {
    this.platformConfig = this.configLoaderService.getPlatformConfig();
  }

  ngOnInit() {
    this.photoFormControl.registerOnChange(
      (value) => {
        this.checkFormValue();
      }
    );
    this.checkFormValue();
  }

  checkFormValue() {
    if (this.photoFormControl.value !== null) {
      if (this.photoFormControl.value.path !== null && this.photoFormControl.value.path !== undefined) {
        this.mediaUrl = this.mediaBaseUrl + this.photoFormControl.value.path;
      } else {
        this.mediaUrl = this.photoFormControl.value;
      }
    } else {
      this.mediaUrl = null;
    }
  }

  onChangeMedia(e) {
    const reader = new FileReader();
    const file = e.target.files[0];

    if (file === 'undefined' || file === null) {
      this.mediaUrl = null;
    } else {
      this.mediaLoading = true;
      reader.onloadend = () => {
        this.mediaUrl = reader.result;
      };
      reader.readAsDataURL(file);

      this.mediaService.postMedia(file).subscribe(
        (response) => {
          this.photoFormControl.setValue(response);
          this.mediaLoading = false;
          e.target.value = null;
          this.onMediaSelected.emit(this.photoFormControl.value);
        }
      );

    }

  }

  onDeleteMedia() {
    this.mediaUrl = null;
    this.photoFormControl.setValue(null);
    this.mediaLoading = false;
    this.onMediaSelected.emit(null);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/photo-block/photo-block.component.ts